import { render } from "./BuyDogComponent.vue?vue&type=template&id=60309e2c&ts=true"
import script from "./BuyDogComponent?vue&type=script&lang=ts"
export * from "./BuyDogComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__